import React from "react"
import type { ParametrosAplicativoModel } from "../models/parametrosAplicativoModel"
import { ParametrosAplicativoInicial } from "../models/parametrosAplicativoModel"
import type { ParametrosAplicativoActionModel } from "./parametrosAplicativoActions"
import { parametrosAplicativoReducer } from "./parametrosAplicativoReducer"

type ParametrosAplicativoContextType = {
    parametros: ParametrosAplicativoModel
    dispatch: React.Dispatch<ParametrosAplicativoActionModel>
    salvar: () => Promise<void>
    erroCarregamento: string | null
}

export const ParametrosAplicativoContext =
    React.createContext<ParametrosAplicativoContextType>({
        parametros: ParametrosAplicativoInicial,
        dispatch: () => parametrosAplicativoReducer(ParametrosAplicativoInicial, {
            type: "CARREGAR" as never,
            payload: ParametrosAplicativoInicial,
        }),
        salvar: async () => {},
        erroCarregamento: null,
    })
